
const Terminal = ({ title, children }) => {
    return (
        <>
            <div className="max-w-lg mx-auto border dark:border-gray-300 border-gray-400 rounded-lg shadow-lg bg-slate-200 dark:bg-gray-800">
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-2 bg-slate-400 dark:bg-gray-700 rounded-t-lg">
                    <div className="flex space-x-2">
                        <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                        <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                        <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="flex space-x-4 px-4 dark:bg-gray-800 bg-slate-300 dark:border-gray-600">
                    <div className="py-2 px-3 mt-2 dark:bg-gray-900 bg-slate-200 dark:text-gray-100 text-gray-900 rounded-t-md font-mono text-sm">
                        {title}.py
                    </div>
                </div>

                {/* Code Area */}
                <div className="p-4 dark:bg-gray-900 bg-slate-200 dark:text-gray-100 text-gray-900 font-mono sm:min-h-48 text-xs sm:text-sm overflow-auto rounded-b-lg">
                    <pre
                        style={{
                            whiteSpace: "pre-wrap", // Preserves whitespace and enables wrapping
                            wordBreak: "break-word", // Forces long words to break to fit the container
                        }}>
                        <code>
                            {children}
                        </code>
                    </pre>
                </div>
            </div>





        </>
    )
}


export default Terminal;